export const normalizeRoles = (role) =>
  Array.isArray(role) ? role.filter(Boolean) : role ? [role] : [];

export const hasRole = (user, ...allowed) =>
  normalizeRoles(user?.role).some((r) => allowed.includes(r));

export const validateRole = () => {
  const dataAuth = localStorage.getItem("auth");
  const dataUser = JSON.parse(dataAuth);

  if (hasRole(dataUser, "pr_admin", "pr_user", "pr_checker")) {
    return "PR";
  } else if (hasRole(dataUser, "sp_admin", "sp_user")) {
    return "SP";
  } else if (hasRole(dataUser, "super_user", "ppic_admin")) {
    return "super";
  } else {
    return "";
  }
};

export const formatDot = (value) => {
  return value && value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
};

export const numberWithCommas = (data) => {
  let dataTemp =
    data &&
    data.toLocaleString("en-US", {
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
    });
  return dataTemp;
};

export const switchDotsAndCommas = (s) => {
  function switcher(match) {
    return match === "," ? "." : ",";
  }
  return s && s.replaceAll(/\.|\,/g, switcher);
};
